import React, { PureComponent } from 'react';
import Big from 'big.js';
import classNames from 'classnames';

import { BaseInputProps } from '../types';
import { Input, InputNumber } from 'antd';

export interface NumProps extends BaseInputProps {
  value?: number;

  onChange?(val?: number): void;

  isPercentage?: boolean;

  /**
   * @default 'Value'
   * */
  placeholder?: string;
  inputWidth?: number;
  className?: string;
}

export class NumCvt {
  static show(val?: number, isPercentage?: boolean) {
    if (val && isPercentage) return Big(val).times(100).valueOf();
    return String(val ?? '');
  }

  static emit(val: string, isPercentage?: boolean) {
    if (!val || val === '-') return undefined;
    if (!isPercentage) return +val;
    return +Big(val).div(100);
  }
}

function initState(props: NumProps) {
  return {
    preProps: props,
    tempValue: NumCvt.show(props.value, props.isPercentage),
  };
}

export type NumState = ReturnType<typeof initState>;

export class Num extends PureComponent<NumProps, NumState> {
  static getDerivedStateFromProps(props: NumProps, state: NumState) {
    if (
      props.value !== state.preProps.value &&
      NumCvt.emit(state.tempValue, props.isPercentage) !== props.value
    ) {
      state.tempValue = NumCvt.show(props.value, props.isPercentage);
    }
    return { ...state, preProps: props };
  }

  state = initState(this.props);

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const $value = e.target.value.trim();
    const $val = $value.replace(/^(-?\d+(\.\d*)?|-?\d*).*$/, '$1');
    if ($val !== $value) e.target.value = $val;

    const value = NumCvt.emit($val, this.props.isPercentage);

    this.setState(
      pre => ({ ...pre, tempValue: e.target.value }),
      () => {
        if (value !== this.props.value) this.props.onChange?.(value);
      },
    );
  };

  onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '-') e.target.value = '';
    this.props.onBlur?.();
  };

  render() {
    return (
      <div
        className={this.props.className}
      >
        {this.props.readonly ? (
          <span>
            {`${this.state.tempValue}${this.props.isPercentage ? '%' : ''}` || 'N/A'}
          </span>
        ) : (
          <Input
            style={{ width: '100%' }}
            placeholder={this.props.placeholder || 'Value'}
            value={this.state.tempValue || ''}
            onChange={this.onChange}
            onBlur={this.onBlur}
            autoComplete="off"
            // controls={false}
            addonAfter={this.props.isPercentage ? '%' : false}
          />
        )}
      </div>
    );
  }
}
